import Vuex from 'vuex';
import Vue from 'vue';
import offices from '@/store/modules/offices'
import bookings from '@/store/modules/bookings'
import users from '@/store/modules/users'
import locations from '@/store/modules/locations'

//Load Vuex
Vue.use(Vuex);

//Create Store
export default new Vuex.Store({
    modules: {
        offices,
        bookings,
        users,
        locations
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js